const InspectionStatusIndicator = ({ card, showDefault = false }) => {
  const hasDiag = card.requires_diagnostic_vi;
  const hasVI = card.requires_vehicle_inspection;
  const hasMCC = card.requires_mcc;
  
  // Determine diagnostic status
  const diagDone = card.diagnostic_status === 'completed';
  
  // Determine VI status
  const viDone = card.vi_status === 'submitted';
  
  // Determine MCC status — the tester's Manual Capture Card is
  // "submitted" once Submit-to-FOH has been pressed (backend stamps
  // mot_result_outcome_id + ready_for_foh_at).
  const mccDone = card.mcc_status === 'submitted';
  
  // If neither is explicitly set but showDefault is true, show VI as pending (default inspection type)
  const showDefaultVI = showDefault && !hasDiag && !hasVI && !hasMCC;
  
  // Only show if at least one inspection type is required or showDefault is true
  if (!hasDiag && !hasVI && !hasMCC && !showDefault) return null;
  
  return (
    <div className="flex gap-1 mt-1 flex-wrap">
      {hasDiag && (
        <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
          diagDone 
            ? 'bg-green-100 text-green-700 border border-green-300' 
            : 'bg-red-100 text-red-700 border border-red-300'
        }`}
        data-testid={`inspection-indicator-diag-${diagDone ? 'done' : 'pending'}`}>
          {diagDone ? '✓' : '○'} Diag
        </span>
      )}
      {(hasVI || showDefaultVI) && (
        <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
          viDone 
            ? 'bg-green-100 text-green-700 border border-green-300' 
            : 'bg-yellow-100 text-yellow-700 border border-yellow-300'
        }`}
        data-testid={`inspection-indicator-vi-${viDone ? 'done' : 'pending'}`}>
          {viDone ? '✓' : '○'} VI
        </span>
      )}
      {hasMCC && (
        <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
          mccDone 
            ? 'bg-green-100 text-green-700 border border-green-300' 
            : 'bg-yellow-100 text-yellow-700 border border-yellow-300'
        }`}
        data-testid={`inspection-indicator-mcc-${mccDone ? 'done' : 'pending'}`}>
          {mccDone ? '✓' : '○'} MCC
        </span>
      )}
    </div>
  );
};

export default InspectionStatusIndicator;
